import { Component, computed, EventEmitter, input, Input, OnInit, Output, Type } from '@angular/core';
import { InputsType, OutputsType } from 'ng-dynamic-component';
import { BehaviorSubject } from 'rxjs';

import { ViewerToolbarTool } from 'src/index';
import {
    LiquidViewerToolbarConfiguration
} from '../liquid-viewer.models';

@Component({
    selector: 'meta-liquid-toolbar',
    templateUrl: './liquid-toolbar.component.html',
    styleUrls: ['./liquid-toolbar.component.css']
})
export class LiquidToolbarComponent implements OnInit {
    private _defaultConfig: Partial<LiquidViewerToolbarConfiguration> = {
        position: 'left',
        mobilePosition: 'bottom',
        floating: true,
    };
    config = input<Partial<LiquidViewerToolbarConfiguration>>();
    $config = computed(() => ({
        ...this._defaultConfig,
        ...this.config(),
    }));

    @Input() toolbarTools: ViewerToolbarTool[] = [];
    @Input() toolbarLinks: ViewerToolbarTool[] = [];

    @Output() toolClicked = new EventEmitter<ViewerToolbarTool>();
    @Output() panelClosed = new EventEmitter<void>();
    @Output() panelOpened = new EventEmitter<void>();

    toolbarPanelContent$ = new BehaviorSubject<{
        id: string;
        component: Type<any>;
        dynamicInputs: InputsType,
        dynamicOutputs: OutputsType,
    } | undefined>(undefined);
    activeTool: ViewerToolbarTool | undefined;

    constructor() { }

    ngOnInit(): void {
        this._activateToolFromConfig();
    }

    handleToolClick(tool: ViewerToolbarTool) {
        this.toolClicked.emit(tool);
        if (!tool.disabled) {
            if (tool.isToggler) {
                if (!tool.active) {

                    this.activeTool = tool;
                    tool.active = true;

                    this.toolbarTools.forEach(tool => {
                        if (tool.id !== this.activeTool!.id) {
                            tool.active = false;
                        }
                    });

                    this.toolbarLinks.forEach(tool => {
                        if (tool.id !== this.activeTool!.id) {
                            tool.active = false;
                        }
                    });

                    if (tool.panelComponent?.component) {
                        this.toolbarPanelContent$.next({
                            id: tool.id,
                            component: tool.panelComponent?.component,
                            dynamicInputs: tool.panelComponent?.dynamicInputs ?? {},
                            dynamicOutputs: {
                                ...tool.panelComponent?.dynamicOutputs ?? {},
                                giveBackFocus: () => document.getElementById(tool.id)?.focus(),
                            },
                        });
                        this.panelOpened.emit();
                    }

                } else {
                    tool.active = false;
                    this.toolbarPanelContent$.next(undefined);
                    this.activeTool = undefined;
                    this.panelClosed.emit();
                }
            }

            if (tool.callback) {
                tool.callback();
            }
        }
    }

    closeToolbarPanelContent() {
        this.toolbarPanelContent$.next(undefined);
        if (this.activeTool) {
            this.handleToolClick(this.activeTool);
        }
        this.panelClosed.emit();
    }

    private _activateToolFromConfig() {
        if (this.$config().activeToolId) {
            const activeTool = this.toolbarTools.find(t => t.id == this.$config().activeToolId);
            if (activeTool) {
                this.handleToolClick(activeTool);
            }
        }
    }
}
